import { createAsyncThunk } from '@reduxjs/toolkit'
import PlayerRole from './player-role-model'
import {
  delete_playerRole,
  load_playerRoles,
  store_playerRole,
} from './playerRole-service'

export const LoadPlayerRolesAsync = createAsyncThunk<any, any>(
  'composer/load/playerRole',
  async (params: { uid: string }) => {
    return await load_playerRoles(params)
  },
)

export const CreatePlayerRoleAsync = createAsyncThunk<any, any>(
  'composer/create/playerRole',
  async (params: PlayerRole) => {
    return await store_playerRole(params)
  },
)

export const DeletePlayerRoleAsync = createAsyncThunk<any, any>(
  'composer/delete/playerRole',
  async (params) => {
    return await delete_playerRole(params)
  },
)
